<template>
  <div class="demographicInterest">
    <adx-list-item :data='data' :type="`bar`" />
  </div>
</template>

<script>
import ListItem from '@/components/ListDemographic'

import api from '@/api'
import { apiV2 } from '@/api/urls'

export default {
  name: 'adx-campaignreport-demographic-interest',
  components: {
    'adx-list-item': ListItem
  },
  props: {

  },
  data() {
    return {
      data: {
        header: ['INTEREST', 'USER'],
        body: []
      }
    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {
    this.loadData()
  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    async loadData() {
      const { status, data } = await api.get(apiV2.measurementcampaignReportDetail(this.$route.params.campaign_id), { needToken: true })
      if(status == 200) {
        let { get_all_interest } = await data
        // get_all_interest = [
        //   {
        //     'id' : 1,
        //     'name' : "Fun" ,
        //     'percentage' : 0.2
        //   }, 
        //   {
        //     'id' : 2,
        //     'name' : "Sport" ,
        //     'percentage' : 0.5
        //   },
        //   {
        //     'id' : 3,
        //     'name' : "Food" ,
        //     'percentage' : 0.3
        //   }
        // ]
        let {total_traffic} = await data

        this.data.body = Object.keys(get_all_interest).map((key, index) => {
          return {
            'name': get_all_interest[key].name,
            'user': get_all_interest[key].percentage,
            'total': Math.round(get_all_interest[key].percentage * total_traffic /100)
          }
        });
      }
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>